"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6313,3061,9150],{

/***/ 99126:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O8": function() { return /* binding */ apstagBidCallback; },
/* harmony export */   "PI": function() { return /* binding */ createApsSlotsRosMobile; },
/* harmony export */   "VG": function() { return /* binding */ createApsSlotsRosDesktop; },
/* harmony export */   "WX": function() { return /* binding */ requestBiddingFromPWT; },
/* harmony export */   "Zy": function() { return /* binding */ createApsSlotsHomeMobile; },
/* harmony export */   "we": function() { return /* binding */ createApsSlotsHomeDesktop; }
/* harmony export */ });
/* unused harmony exports DEFAULT_HOME_MOBILE, createApsSlotsRosDesktopFalse, createApsSlotsRosMobileFalse */
// import { logger } from "./logging/log-util";
var requestBiddingFromPWT = function requestBiddingFromPWT() {
  console.log("AdsTest requestBiddingFromPWT"); // logger.info("requestBiddingFromPWT");

  if (typeof PWT.requestBids === "function") {
    console.log("AdsTest requestBiddingFromPWT inside if");
    PWT.requestBids(PWT.generateConfForGPT(googletag.pubads().getSlots()), function (adUnitsArray) {
      // logger.info("bids received from PWT", adUnitsArray);
      PWT.addKeyValuePairsToGPTSlots(adUnitsArray);
      PWT.ow_BidsReceived = true;
      window.initAdserver(false);
    });
  }

  var FAILSAFE_TIMEOUT = 1000; // this timeout should > OpenWrap and TAM timeout

  setTimeout(function () {
    window.initAdserver(true); // calling this function with forced mode set to true so that GPT API is always executed
  }, FAILSAFE_TIMEOUT);
};
function apstagBidCallback(bids) {
  // logger.info("apstagBidCallback - received bids", bids);
  googletag.cmd.push(function () {
    apstag.setDisplayBids();
    PWT.TAM_BidsReceived = true;
    window.initAdserver(false);
  });
}
var DEFAULT_HOME_MOBILE = [{
  slotID: "div-gpt-ad-1657866020444-0",
  sizes: [[300, 250]]
}, {
  slotID: "div-gpt-ad-1657866205249-0",
  sizes: [[300, 250]]
}, {
  slotID: "div-gpt-ad-1657866282643-0",
  sizes: [[300, 250]]
}, {
  slotID: "div-gpt-ad-1657866338810-0",
  sizes: [[300, 250]]
}, {
  slotID: "div-gpt-ad-1657866406380-0",
  sizes: [[300, 250]]
}, {
  slotID: "div-gpt-ad-1657866608917-0",
  sizes: [[320, 50]]
}];
var createApsSlotsRosDesktopFalse = function createApsSlotsRosDesktopFalse(_ref) {
  var _ref$atf = _ref.atf,
      atf = _ref$atf === void 0 ? false : _ref$atf,
      _ref$atf2 = _ref.atf300,
      atf300 = _ref$atf2 === void 0 ? false : _ref$atf2,
      _ref$mtf = _ref.mtf1,
      mtf1 = _ref$mtf === void 0 ? false : _ref$mtf,
      _ref$mtf2 = _ref.mtf2,
      mtf2 = _ref$mtf2 === void 0 ? false : _ref$mtf2,
      _ref$mtf3 = _ref.mtf3,
      mtf3 = _ref$mtf3 === void 0 ? false : _ref$mtf3,
      _ref$btf = _ref.btf,
      btf = _ref$btf === void 0 ? false : _ref$btf;
  createApsSlotsRosDesktop({
    atf: atf,
    atf300: atf300,
    mtf1: mtf1,
    mtf2: mtf2,
    mtf3: mtf3,
    btf: btf
  });
};
var createApsSlotsRosDesktop = function createApsSlotsRosDesktop(_ref2) {
  var _ref2$atf = _ref2.atf,
      atf = _ref2$atf === void 0 ? true : _ref2$atf,
      _ref2$atf2 = _ref2.atf300,
      atf300 = _ref2$atf2 === void 0 ? true : _ref2$atf2,
      _ref2$mtf = _ref2.mtf1,
      mtf1 = _ref2$mtf === void 0 ? true : _ref2$mtf,
      _ref2$mtf2 = _ref2.mtf2,
      mtf2 = _ref2$mtf2 === void 0 ? true : _ref2$mtf2,
      _ref2$mtf3 = _ref2.mtf3,
      mtf3 = _ref2$mtf3 === void 0 ? true : _ref2$mtf3,
      _ref2$btf = _ref2.btf,
      btf = _ref2$btf === void 0 ? true : _ref2$btf;
  var slots = [];

  if (atf) {
    slots.push({
      slotID: "div-gpt-ad-1701945163318-0",
      sizes: [[728, 90]]
    });
  }

  if (atf300) {
    slots.push({
      slotID: "div-gpt-ad-1701945220410-0",
      sizes: [[300, 250]]
    });
  }

  if (mtf1) {
    slots.push({
      slotID: "div-gpt-ad-1701945220410-1",
      sizes: [[728, 90]]
    });
  }

  if (mtf2) {
    slots.push({
      slotID: "div-gpt-ad-1701945220410-2",
      sizes: [[728, 90]]
    });
  }

  if (mtf3) {
    slots.push({
      slotID: "div-gpt-ad-1701945220410-3",
      sizes: [[728, 90]]
    });
  }

  if (btf) {
    slots.push({
      slotID: "div-gpt-ad-1701945864013-0",
      sizes: [[728, 90]]
    });
  }

  console.log("slotss 1s", slots);
  return slots;
}; // Just a warpper with default false value

var createApsSlotsRosMobileFalse = function createApsSlotsRosMobileFalse(_ref3) {
  var _ref3$atf = _ref3.atf,
      atf = _ref3$atf === void 0 ? false : _ref3$atf,
      _ref3$mtf = _ref3.mtf1,
      mtf1 = _ref3$mtf === void 0 ? false : _ref3$mtf,
      _ref3$mtf2 = _ref3.mtf2,
      mtf2 = _ref3$mtf2 === void 0 ? false : _ref3$mtf2,
      _ref3$mtf3 = _ref3.mtf3,
      mtf3 = _ref3$mtf3 === void 0 ? false : _ref3$mtf3,
      _ref3$btf = _ref3.btf,
      btf = _ref3$btf === void 0 ? false : _ref3$btf,
      _ref3$bottom = _ref3.bottom,
      bottom = _ref3$bottom === void 0 ? false : _ref3$bottom;
  console.log("atf,mtf", atf, mtf1, mtf2, mtf3, btf, bottom);
  createApsSlotsRosMobile({
    atf: atf,
    mtf1: mtf1,
    mtf2: mtf2,
    mtf3: mtf3,
    btf: btf,
    bottom: bottom
  });
};
var createApsSlotsRosMobile = function createApsSlotsRosMobile(_ref4) {
  var _ref4$atf = _ref4.atf,
      atf = _ref4$atf === void 0 ? true : _ref4$atf,
      _ref4$mtf = _ref4.mtf1,
      mtf1 = _ref4$mtf === void 0 ? true : _ref4$mtf,
      _ref4$mtf2 = _ref4.mtf2,
      mtf2 = _ref4$mtf2 === void 0 ? true : _ref4$mtf2,
      _ref4$mtf3 = _ref4.mtf3,
      mtf3 = _ref4$mtf3 === void 0 ? true : _ref4$mtf3,
      _ref4$btf = _ref4.btf,
      btf = _ref4$btf === void 0 ? true : _ref4$btf,
      _ref4$bottom = _ref4.bottom,
      bottom = _ref4$bottom === void 0 ? true : _ref4$bottom;
  console.log("calsfdwsdf");
  var slots = [];

  if (atf) {
    slots.push({
      slotID: "div-gpt-ad-1701946028239-0",
      sizes: [[300, 250]]
    });
  }

  if (mtf1) {
    slots.push({
      slotID: "div-gpt-ad-1701946028239-1",
      sizes: [[300, 250]]
    });
  }

  if (mtf2) {
    slots.push({
      slotID: "div-gpt-ad-1701946028239-2",
      sizes: [[300, 250]]
    });
  } // if (mtf3) {
  //   slots.push({
  //     slotID: "div-gpt-ad-1701946028239-3",
  //     sizes: [[300, 250]],
  //   });
  // }


  if (btf) {
    slots.push({
      slotID: "div-gpt-ad-1701946028239-3",
      sizes: [[300, 250]]
    });
  }

  if (bottom) {
    slots.push({
      slotID: "div-gpt-ad-1701946324333-0",
      sizes: [[320, 50]]
    });
  }

  return slots;
};
var createApsSlotsHomeDesktop = function createApsSlotsHomeDesktop(_ref5) {
  var _ref5$atf = _ref5.atf,
      atf = _ref5$atf === void 0 ? true : _ref5$atf,
      _ref5$atf2 = _ref5.atf300,
      atf300 = _ref5$atf2 === void 0 ? true : _ref5$atf2,
      _ref5$mtf = _ref5.mtf1,
      mtf1 = _ref5$mtf === void 0 ? true : _ref5$mtf,
      _ref5$mtf2 = _ref5.mtf2,
      mtf2 = _ref5$mtf2 === void 0 ? true : _ref5$mtf2,
      _ref5$mtf3 = _ref5.mtf3,
      mtf3 = _ref5$mtf3 === void 0 ? true : _ref5$mtf3,
      _ref5$btf = _ref5.btf,
      btf = _ref5$btf === void 0 ? true : _ref5$btf;
  console.log("AdsTest createApsSlotsHomeDesktop");
  var slots = [];

  if (atf) {
    slots.push({
      slotID: "div-gpt-ad-1701945163318-0",
      sizes: [[728, 90], [970, 250], [970, 90]]
    });
  }

  if (atf300) {
    slots.push({
      slotID: "div-gpt-ad-1701945220410-0",
      sizes: [[728, 90], [970, 250], [970, 90]]
    });
  }

  if (mtf1) {
    slots.push({
      slotID: "div-gpt-ad-1701945220410-1",
      sizes: [[728, 90], [970, 250], [970, 90]]
    });
  }

  if (mtf2) {
    slots.push({
      slotID: "div-gpt-ad-1701945220410-2",
      sizes: [[728, 90], [970, 250], [970, 90]]
    });
  }

  if (mtf3) {
    slots.push({
      slotID: "div-gpt-ad-1701945220410-4",
      sizes: [[728, 90], [970, 90]]
    });
  }

  if (btf) {
    slots.push({
      slotID: "div-gpt-ad-1701945220410-3",
      sizes: [[300, 250]]
    });
  }

  console.log("AdsTest createApsSlotsHomeDesktop slots are", slots);
  return slots;
};
var createApsSlotsHomeMobile = function createApsSlotsHomeMobile(_ref6) {
  var _ref6$atf = _ref6.atf,
      atf = _ref6$atf === void 0 ? true : _ref6$atf,
      _ref6$mtf = _ref6.mtf1,
      mtf1 = _ref6$mtf === void 0 ? true : _ref6$mtf,
      _ref6$mtf2 = _ref6.mtf2,
      mtf2 = _ref6$mtf2 === void 0 ? true : _ref6$mtf2,
      _ref6$mtf3 = _ref6.mtf3,
      mtf3 = _ref6$mtf3 === void 0 ? true : _ref6$mtf3,
      _ref6$btf = _ref6.btf,
      btf = _ref6$btf === void 0 ? true : _ref6$btf,
      _ref6$bottom = _ref6.bottom,
      bottom = _ref6$bottom === void 0 ? true : _ref6$bottom;
  var slots = [];

  if (atf) {
    slots.push({
      slotID: "div-gpt-ad-1701946028239-0",
      sizes: [[300, 250]]
    });
  }

  if (mtf1) {
    slots.push({
      slotID: "div-gpt-ad-1701946028239-1",
      sizes: [[300, 250]]
    });
  }

  if (mtf2) {
    slots.push({
      slotID: "div-gpt-ad-1701946028239-2",
      sizes: [[300, 250]]
    });
  }

  if (mtf3) {
    slots.push({
      slotID: "div-gpt-ad-1701946028239-4",
      sizes: [[300, 250]]
    });
  }

  if (btf) {
    slots.push({
      slotID: "div-gpt-ad-1701946028239-3",
      sizes: [[300, 250]]
    });
  }

  if (bottom) {
    slots.push({
      slotID: "div-gpt-ad-1701946324333-0",
      sizes: [[320, 50]]
    });
  }

  return slots;
};

/***/ }),

/***/ 66707:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _fontsize_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16698);
/* harmony import */ var _fontsize_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_fontsize_module_scss__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);




var FontSize = function FontSize(_ref) {
  var setFontSize = _ref.setFontSize,
      fontSize = _ref.fontSize;

  var handleFS = function handleFS(size) {
    if (window && window.localStorage !== undefined) {
      if (size) {
        localStorage.removeItem("fontSize");
        localStorage.setItem("fontSize", size);
        setFontSize(size);
      }
    }
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
    title: "Font Size",
    className: (_fontsize_module_scss__WEBPACK_IMPORTED_MODULE_1___default().dropdown),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
      role: "button",
      className: (_fontsize_module_scss__WEBPACK_IMPORTED_MODULE_1___default().dropbtn),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
        height: "22px",
        width: "22px",
        src: "/assets/images/font-size.png",
        style: {
          height: "22px",
          marginBottom: "4px"
        },
        alt: "font-size"
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
      className: (_fontsize_module_scss__WEBPACK_IMPORTED_MODULE_1___default()["dropdown-content"]),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        style: fontSize == "small" ? {
          backgroundColor: "#f1f1f1"
        } : {},
        onClick: function onClick() {
          return handleFS("small");
        },
        role: "button",
        children: "Small"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        style: fontSize == "normal" ? {
          backgroundColor: "#f1f1f1"
        } : {},
        onClick: function onClick() {
          return handleFS("normal");
        },
        role: "button",
        children: "Medium"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        style: fontSize == "large" ? {
          backgroundColor: "#f1f1f1"
        } : {},
        onClick: function onClick() {
          return handleFS("large");
        },
        role: "button",
        children: "Large"
      })]
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (FontSize);

/***/ }),

/***/ 97208:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IQ": function() { return /* binding */ removeHtmlTags; },
/* harmony export */   "OK": function() { return /* binding */ adsPositioning; },
/* harmony export */   "Pj": function() { return /* binding */ formatDateIST; },
/* harmony export */   "VG": function() { return /* binding */ timeSince; },
/* harmony export */   "WJ": function() { return /* binding */ divideArrayIntoColumns; },
/* harmony export */   "ZY": function() { return /* binding */ getMonthName; },
/* harmony export */   "ac": function() { return /* binding */ formatDateISTCricket; },
/* harmony export */   "er": function() { return /* binding */ adsDiv; },
/* harmony export */   "kg": function() { return /* binding */ formatDateEnglishOnly; },
/* harmony export */   "p6": function() { return /* binding */ formatDate; },
/* harmony export */   "q3": function() { return /* binding */ removeEmbeds; },
/* harmony export */   "t4": function() { return /* binding */ myCustomSplit; }
/* harmony export */ });
/* unused harmony exports msToTime, formatDateDefault, isoStringWithOffset, shimmer, toBase64 */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);


var timeSince = function timeSince(date) {
  var seconds = Math.floor((new Date() - new Date(date)) / 1000);
  var interval = seconds / 31536000;

  if (interval > 1) {
    var toReturn = Math.floor(interval);
    return "".concat(toReturn, " ").concat(toReturn === 1 ? "year" : "years");
  }

  interval = seconds / 2592000;

  if (interval > 1) {
    var _toReturn = Math.floor(interval);

    return "".concat(_toReturn, " ").concat(_toReturn === 1 ? "month" : "months");
  }

  interval = seconds / 86400;

  if (interval > 1) {
    var _toReturn2 = Math.floor(interval);

    return "".concat(_toReturn2, " ").concat(_toReturn2 === 1 ? "day" : "days");
  }

  interval = seconds / 3600;

  if (interval > 1) {
    var _toReturn3 = Math.floor(interval);

    return "".concat(_toReturn3, " ").concat(_toReturn3 === 1 ? "hour" : "hours");
  }

  interval = seconds / 60;

  if (interval > 1) {
    var _toReturn4 = Math.floor(interval);

    return "".concat(_toReturn4, " ").concat(_toReturn4 === 1 ? "minute" : "minutes");
  }

  var finalSeconds = Math.floor(seconds);
  return (finalSeconds >= 0 ? finalSeconds : 0) + " seconds";
};
var msToTime = function msToTime(duration) {
  var milliseconds = parseInt(duration % 1000 / 100),
      seconds = Math.floor(duration / 1000 % 60),
      minutes = Math.floor(duration / (1000 * 60) % 60),
      hours = Math.floor(duration / (1000 * 60 * 60) % 24);
  hours = hours < 10 ? "0" + hours : hours;
  minutes = minutes < 10 ? "0" + minutes : minutes;
  seconds = seconds < 10 ? "0" + seconds : seconds;
  if (hours > 0) return hours + ":" + minutes + ":" + seconds;
  return minutes + ":" + seconds;
};
var formatDate = function formatDate(dateString) {
  var dateOptions = {
    year: "numeric",
    month: "long",
    day: "numeric"
  };
  var timeOptions = {
    hour: "2-digit",
    minute: "2-digit"
  };
  return {
    date: new Date(dateString).toLocaleDateString("hi-IN", dateOptions),
    time: new Date(dateString).toLocaleTimeString("en-US", timeOptions)
  };
};
var formatDateEnglishOnly = function formatDateEnglishOnly(dateString) {
  var dateOptions = {
    year: "numeric",
    month: "long",
    day: "numeric"
  };
  var timeOptions = {
    hour: "2-digit",
    minute: "2-digit"
  };
  return {
    date: new Date(dateString).toLocaleDateString("en-US", dateOptions),
    time: new Date(dateString).toLocaleTimeString("en-US", timeOptions)
  };
};
var formatDateIST = function formatDateIST(dateString) {
  var dateOptions = {
    year: "numeric",
    month: "long",
    day: "numeric"
  };
  var timeOptions = {
    timeZone: "Asia/Kolkata",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false
  };
  return {
    date: new Date(dateString).toLocaleDateString("hi-IN", dateOptions),
    time: new Date(dateString).toLocaleString("en-US", timeOptions)
  };
};
var formatDateISTCricket = function formatDateISTCricket(dateString) {
  var date = new Date(dateString);
  date.setHours(date.getHours() + 5);
  date.setMinutes(date.getMinutes() + 30);
  var dateOptions = {
    weekday: "short",
    month: "short",
    day: "numeric"
  };
  var timeOptions = {
    timeZone: "Asia/Kolkata",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true
  };
  return {
    date: new Date(date).toLocaleDateString("en-US", dateOptions),
    time: new Date(date).toLocaleString("en-US", timeOptions)
  };
};
var formatDateDefault = function formatDateDefault(date) {
  date.setHours(date.getHours() + 5);
  date.setMinutes(date.getMinutes() + 30);
  var hour = date.getHours();
  var minute = date.getMinutes();
  var second = date.getSeconds();

  if (hour > 12) {
    hour = hour - 12;
  }

  if (hour == 0) {
    hour = 12;
  }

  if (hour < 10) {
    hour = "0" + hour;
  }

  if (minute < 10) {
    minute = "0" + minute;
  }

  if (second < 10) {
    second = "0" + second;
  }

  var timeString = hour + ":" + minute + ":" + second + " ";
  return date.toISOString().substring(0, 10) + " ".concat(timeString);
};
var getMonthName = function getMonthName(date) {
  var _monthNames$date$getM;

  var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  return (_monthNames$date$getM = monthNames[date.getMonth()]) === null || _monthNames$date$getM === void 0 ? void 0 : _monthNames$date$getM.slice(0, 3);
};
var isoStringWithOffset = function isoStringWithOffset(date) {
  date = new Date(date);

  var tzo = -date.getTimezoneOffset(),
      dif = tzo >= 0 ? "+" : "-",
      pad = function pad(num) {
    return (num < 10 ? "0" : "") + num;
  };

  return date.getFullYear() + "-" + pad(date.getMonth() + 1) + "-" + pad(date.getDate()) + "T" + pad(date.getHours()) + ":" + pad(date.getMinutes()) + ":" + pad(date.getSeconds()) + dif + pad(Math.floor(Math.abs(tzo) / 60)) + ":" + pad(Math.abs(tzo) % 60);
};
var shimmer = function shimmer(w, h) {
  return "\n<svg width=\"".concat(w, "\" height=\"").concat(h, "\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n  <defs>\n    <linearGradient id=\"g\">\n      <stop stop-color=\"#333\" offset=\"20%\" />\n      <stop stop-color=\"#222\" offset=\"50%\" />\n      <stop stop-color=\"#333\" offset=\"70%\" />\n    </linearGradient>\n  </defs>\n  <rect width=\"").concat(w, "\" height=\"").concat(h, "\" fill=\"#333\" />\n  <rect id=\"r\" width=\"").concat(w, "\" height=\"").concat(h, "\" fill=\"url(#g)\" />\n  <animate xlink:href=\"#r\" attributeName=\"x\" from=\"-").concat(w, "\" to=\"").concat(w, "\" dur=\"1s\" repeatCount=\"indefinite\"  />\n</svg>");
};
var toBase64 = function toBase64(str) {
  return  false ? 0 : window.btoa(str);
};
var myCustomSplit = function myCustomSplit(str) {
  var _outputArr;

  var outputArr = [];
  outputArr = str === null || str === void 0 ? void 0 : str.split("</p>");
  (_outputArr = outputArr) === null || _outputArr === void 0 ? void 0 : _outputArr.map(function (data, index) {
    outputArr[index] = outputArr[index] + "</p>";
  });
  var totalo = 0; //Total opening blockquote tags

  var totalc = 0; // Total closing blockquote tags

  for (var x = 0; x < ((_outputArr2 = outputArr) === null || _outputArr2 === void 0 ? void 0 : _outputArr2.length); x++) {
    var _outputArr2, _outputArr$x, _outputArr$x2;

    var opening = ((_outputArr$x = outputArr[x]) === null || _outputArr$x === void 0 ? void 0 : _outputArr$x.split("<blockquote").length) - 1;
    /*  Counts how many opening and closing blockquote tags
        are there on the current position of the array  */

    var closing = ((_outputArr$x2 = outputArr[x]) === null || _outputArr$x2 === void 0 ? void 0 : _outputArr$x2.split("</blockquote>").length) - 1;
    totalo = opening;
    totalc = closing;

    if (closing !== opening) {
      var ind = x;
      /*Keep merging all the indexes ahead to outputArr[ind] 
           till the time we achieve closing===opening */

      while (true) {
        var _outputArr$x3, _outputArr$x4;

        x++;
        outputArr[ind] = outputArr[ind] + outputArr[x];
        var openingInternal = ((_outputArr$x3 = outputArr[x]) === null || _outputArr$x3 === void 0 ? void 0 : _outputArr$x3.split("<blockquote").length) - 1;
        var closingInternal = ((_outputArr$x4 = outputArr[x]) === null || _outputArr$x4 === void 0 ? void 0 : _outputArr$x4.split("</blockquote>").length) - 1;
        outputArr[x] = "";
        totalo = totalo + openingInternal;
        totalc = totalc + closingInternal;

        if (totalo === totalc) {
          totalo = 0;
          totalc = 0;
          break;
        }
      }
    }
  }

  var finalArray = [];

  for (var _x = 0; _x < ((_outputArr3 = outputArr) === null || _outputArr3 === void 0 ? void 0 : _outputArr3.length); _x++) {
    var _outputArr3, _outputArr$_x;

    //Remove all indexes whose length have become 0
    if (((_outputArr$_x = outputArr[_x]) === null || _outputArr$_x === void 0 ? void 0 : _outputArr$_x.length) !== 0) {
      finalArray.push(outputArr[_x]);
    }
  }

  return finalArray;
};
/*Splits the html content by p tag, If we find a
       blockquote tag opening and  and it's respective closing tag in some other
       index below , we will merge all the indexes in between
       to a single index till the opening and closing tag of that blockquote doesnt
       come in 1 index */
// Current Ad logic-
// After 1st,4th

var adsPositioning = function adsPositioning(splitedArray) {
  splitedArray.map(function (article, index) {
    var opening = article.split("<p>").length - 1;
    var closing = article.split("</p>").length - 1;

    if (opening !== closing) {
      splitedArray[index] = splitedArray[index] + "</p>";
    }
  });
  var ar = [];
  ar[0] = splitedArray[0];
  ar[1] = splitedArray[1] !== undefined ? splitedArray[1] : "";
  ar[2] = (splitedArray[2] !== undefined ? splitedArray[2] : "") + (splitedArray[3] !== undefined ? splitedArray[3] : "");
  ar[3] = "";

  for (var x = 4; x < splitedArray.length; x++) {
    ar[3] = ar[3] + splitedArray[x];
  }

  return ar;
};
var adsDiv = function adsDiv(adsId, indexonScreen, articleIndex) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
    className: "container-row py-2 ads-auto-resize",
    align: "center",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
      id: "ads",
      style: {
        fontSize: "11px !important",
        color: "#b7b7b7",
        textAlign: "center",
        marginBottom: "0px"
      },
      children: "Advertisement"
    }), indexonScreen === articleIndex && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
      id: adsId,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
        type: "text/javascript",
        dangerouslySetInnerHTML: {
          __html: "{googletag.cmd.push(function() { googletag.display('".concat(adsId, "')})")
        }
      })
    })]
  });
};
var removeEmbeds = function removeEmbeds(articleHtmlString) {
  var fs = "";
  var len = 7;
  var lenC = 9;

  for (var i = 0; i < articleHtmlString.length; i++) {
    var c = articleHtmlString.charAt(i);

    if (c === "<" && i + len <= articleHtmlString.length && articleHtmlString.substring(i, i + len) === "<script") {
      i = i + len;

      while (articleHtmlString.substring(i, i + lenC) !== "</script>") {
        i++;
      }

      i = i + lenC;
    } else {
      fs = fs + c;
    }
  }

  return fs;
};
function divideArrayIntoColumns(arr, n) {
  if (n <= 0) {
    throw new Error("Number of columns (n) must be greater than 0.");
  }

  var result = [];
  var numRows = Math.ceil(arr.length / n);

  for (var i = 0; i < n; i++) {
    var column = [];

    for (var j = 0; j < numRows; j++) {
      var index = j * n + i;

      if (index < arr.length) {
        column.push(arr[index]);
      }
    }

    result.push(column);
  }

  return result;
}
function removeHtmlTags(input) {
  // Use a regular expression to remove HTML tags
  return input === null || input === void 0 ? void 0 : input.replace(/<[^>]*>/g, "");
}

/***/ }),

/***/ 8969:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ getAdsBySize; }
/* harmony export */ });
/* harmony import */ var _actionTypes_ads_actionTypes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76921);

var getAdsBySize = function getAdsBySize() {
  return {
    type: _actionTypes_ads_actionTypes__WEBPACK_IMPORTED_MODULE_0__/* .GET_ADS_BY_SIZE_INIT */ .vj
  };
};

/***/ }),

/***/ 73295:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bn": function() { return /* binding */ saveBookmark; },
/* harmony export */   "Nf": function() { return /* binding */ getBookmarksByType; },
/* harmony export */   "as": function() { return /* binding */ clearAllBookmarks; }
/* harmony export */ });
/* unused harmony export getBookmarksList */
/* harmony import */ var redux_actionTypes_bookmarks_actionTypes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65999);

var getBookmarksByType = function getBookmarksByType(payload) {
  return {
    type: redux_actionTypes_bookmarks_actionTypes__WEBPACK_IMPORTED_MODULE_0__/* .GET_BOOKMARKS_BY_TYPE_INIT */ .Iv,
    payload: payload
  };
};
var getBookmarksList = function getBookmarksList() {
  return {
    type: GET_BOOKMARKS_LIST_INIT
  };
};
var saveBookmark = function saveBookmark(payload) {
  return {
    type: redux_actionTypes_bookmarks_actionTypes__WEBPACK_IMPORTED_MODULE_0__/* .SAVE_BOOKMARKS_INIT */ .zZ,
    payload: payload
  };
};
var clearAllBookmarks = function clearAllBookmarks(payload) {
  // console.log("clearAllBookmarks", payload)
  return {
    type: redux_actionTypes_bookmarks_actionTypes__WEBPACK_IMPORTED_MODULE_0__/* .DELETE_BOOKMARKS_INIT */ .lP,
    payload: payload
  };
};

/***/ }),

/***/ 25609:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DD": function() { return /* binding */ getLiveShowPost; },
/* harmony export */   "E7": function() { return /* binding */ getTrendingPosts; },
/* harmony export */   "Kw": function() { return /* binding */ storyView; },
/* harmony export */   "Rt": function() { return /* binding */ getRelatedNews; },
/* harmony export */   "fy": function() { return /* binding */ getStats; },
/* harmony export */   "l2": function() { return /* binding */ getLivePostBySocket; },
/* harmony export */   "mT": function() { return /* binding */ postLike; }
/* harmony export */ });
/* unused harmony exports getliveStreamData, allpostData, allFeaturedData, getVisualStoryDetailsById */
/* harmony import */ var redux_actionTypes_post_actionTypes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50406);
 //live show post actions

var getLiveShowPost = function getLiveShowPost() {
  return {
    type: redux_actionTypes_post_actionTypes__WEBPACK_IMPORTED_MODULE_0__/* .LIVESHOWPOST_GET_INIT */ .Jy
  };
};
var getLivePostBySocket = function getLivePostBySocket(payload) {
  return {
    type: redux_actionTypes_post_actionTypes__WEBPACK_IMPORTED_MODULE_0__/* .LIVEPOSTSOCKET_GET_INIT */ .p5,
    payload: payload
  };
}; // trending POSTS

var getTrendingPosts = function getTrendingPosts() {
  return {
    type: redux_actionTypes_post_actionTypes__WEBPACK_IMPORTED_MODULE_0__/* .GET_TRENDING_POST_INIT */ .HK
  };
}; // LIKE-UNLIKE ACTIONS

var postLike = function postLike(payload, postType, postDetails, recordPerPage) {
  //console.log("postdetail",postDetails)
  return {
    type: redux_actionTypes_post_actionTypes__WEBPACK_IMPORTED_MODULE_0__/* .POST_LIKE_INIT */ .Nx,
    payload: payload,
    postType: postType,
    postDetails: postDetails,
    recordPerPage: recordPerPage
  };
}; //GET STATISTICS

var getStats = function getStats(payload) {
  return {
    type: redux_actionTypes_post_actionTypes__WEBPACK_IMPORTED_MODULE_0__/* .GET_STATISTICS_INIT */ .PH,
    payload: payload
  };
}; // live streaming actions

var getliveStreamData = function getliveStreamData(payload) {
  return {
    type: LIVE_STREAM_DATA_INIT,
    payload: payload
  };
}; // stories view Count actions

var storyView = function storyView(payload, postType) {
  return {
    type: redux_actionTypes_post_actionTypes__WEBPACK_IMPORTED_MODULE_0__/* .POST_VIEW_COUNT_INIT */ .V1,
    payload: payload,
    postType: postType
  };
}; // post by categoryType

var allpostData = function allpostData(payload) {
  return {
    type: GET_ALL_POST_INIT,
    payload: payload
  };
}; // post by featuredData

var allFeaturedData = function allFeaturedData(payload) {
  return {
    type: GET_ALL_FEATURED_POST_INIT,
    payload: payload
  };
}; // get visual story by id

var getVisualStoryDetailsById = function getVisualStoryDetailsById(payload) {
  //console.log("called");
  return {
    type: VISUALSTORY_GET_INIT,
    payload: payload
  };
}; // Related ACTIONS

var getRelatedNews = function getRelatedNews(payload) {
  return {
    type: redux_actionTypes_post_actionTypes__WEBPACK_IMPORTED_MODULE_0__/* .GET_RELATED_ARTICLES_INIT */ .GX,
    payload: payload
  };
};

/***/ }),

/***/ 19150:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var logging_log_util__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15079);


function share(share) {
  if (navigator.share) navigator.share(share).then(function () {
    return console.log("Successful share");
  })["catch"](function (error) {
    return logging_log_util__WEBPACK_IMPORTED_MODULE_0__/* .logger.error */ .k.error("Error sharing", error);
  });
}

/* harmony default export */ __webpack_exports__["Z"] = ({
  share: share
});

/***/ })

}]);